import posthog from 'posthog-js'

let posthogInitialized = false

export function initPostHog() {
  if (posthogInitialized) {
    return
  }

  posthog.init('phc_StJVH8DyR3LbsfkBxErKHPwN0efyF29o3kzT3MwiU1i', {
    api_host: 'https://eu.i.posthog.com',
    person_profiles: 'identified_only' // or 'always' to create profiles for anonymous users as well
  })

  posthogInitialized = true
}

// Initialize PostHog if consent was already given
// if (typeof window !== 'undefined' && localStorage.getItem('cookie_consent') === 'accepted') {
  initPostHog()
// }

